<p-message
    class="mt-2"
    [severity]="status()"
    [closable]="closable()"
    (onClose)="onClose()">
    @if (message()) {
        <div class="items-baseline">
            <strong class="mr-2">{{ title[status()] }}</strong>
            <span [innerHtml]="message()"></span>
        </div>
    }
    <ng-content />
</p-message>
